import { render, staticRenderFns } from "./CreateOrEdit.vue?vue&type=template&id=0514ccd0"
import script from "./CreateOrEdit.vue?vue&type=script&lang=ts"
export * from "./CreateOrEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports